export default {
  ok: 'OK',
  add: 'Ajouter',
  save: 'Sauvegarder',
  continue: 'Continuer',
  share: 'Partager',
  quit: 'Quitter',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  end: 'Terminer',
  understand: "J'ai compris",
  restart: 'Recommencer',
  next: 'Suivant',
  skip: 'Passer',
  notFoundError: "Cette page n'existe pas",
  goToHome: "Aller à l'accueil",
  or: 'ou',
  back: 'Retour',
  validation: {
    fieldRequired: 'Ce champ est obligatoire',
  },
  copyLink: 'Copier le lien',
  copied: 'Copié',
  letsGo: "C'est parti !",
  yes: 'Oui',
  no: 'Non',
  other: 'Autre',
  askLater: 'Me demander plus tard',
  showMore: 'Voir plus',
  showLess: 'Voir moins',
  family: {
    code: {
      title: 'Rejoindre une famille',
      description:
        'Entre le code familial pour rejoindre une famille existante',
      submit: 'Rejoindre',
      incomplete: 'Le code doit contenir 6 caractères',
      invalid: 'Code invalide ou expiré',
      success: 'Bienvenue dans la famille !',
      panel: {
        title: 'As-tu un code familial ?',
        description:
          "Si quelqu'un de ta famille t'a envoyé un code, tu peux l'utiliser pour rejoindre sa famille.",
        yes: "Oui, j'ai un code",
        no: "Non, je n'ai pas de code",
      },
    },
  },
};
